export class IconCtaItem {
    fetchKey: string;
    imageUrl: string | null;
    imageHoverUrl: string | null;
    ctaText: string | null;

    constructor(fetchKey: string, imageUrl: string | null, imageHoverUrl: string | null, ctaText: string | null) {
        this.fetchKey = fetchKey;
        this.imageUrl = imageUrl;
        this.imageUrl = imageUrl;
        this.imageHoverUrl = imageHoverUrl;
        this.ctaText = ctaText;
    }

    getImageUrl() : string | undefined {
        if(this.imageUrl == null) return undefined;
        return this.imageUrl;
    }
    getImageHoverUrl() : string | undefined {
        if(this.imageHoverUrl == null) return undefined;
        return this.imageHoverUrl;
    }
}